module.exports = {"pathContext":{"name":"ProductSuggestionType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DIAGNOSTIC"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"IMMUNIZATION"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"MEDICATION"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"TREATMENT"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-product-suggestion-type.json
// module id = 1288
// module chunks = 42016896774740